import styled from 'styled-components'
import { rgba, darken } from 'polished'

export const Container = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1300px;
  /* max-width: 1120px; */
  height: 100%;
  /* max-height: 100vh; */
  padding: 2rem 3rem;
  margin: auto;

  /* overflow: hidden auto; */

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0px;
    width: 100vw;
    height: inherit;

    /* background: url('/images/bgProject.svg') no-repeat top center; */
    transform: translate(-51.5%, 0%);

    filter: blur(4px);
    opacity: 0.6;
    z-index: -1;
  }

  .button {
    width: 100%;
    max-width: 300px;
    height: 4rem;
    margin: 10px 0px 10px 0px;

    font-weight: 600;
    font-size: 1rem;

    background: linear-gradient(
      45deg,
      ${props => props.theme.colors.primary.normal},
      ${props => props.theme.colors.secondary} 100%
    );

    transition: transform 1s ease;
    &:hover {
      transform: scale(1.1);
    }
  }

  .header {
    height: 890px;

    display: grid;
    grid-template-columns: 530px auto;
    /* max-width: 1234px; */
    margin: 0px auto;
    padding: 0px 30px;
    position: relative;

    .title-box {
      width: 100%;
      height: 50%;

      margin-top: 12rem;

      display: grid;
      gap: 2rem;

      h1 {
        line-height: 10rem;
      }

      span {
        font-size: 3rem;
        font-weight: 600;
        overflow-wrap: break-word;

        color: ${props => props.theme.colors.text.title};
      }

      .header-social {
        display: flex;
        align-items: center;
        gap: 1rem;

        a {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 999px;
          border: 1px solid
            ${props => rgba(props.theme.colors.text.normal, 0.25)};
          color: ${props => props.theme.colors.text.normal};

          display: inline-flex;
          align-items: center;
          justify-content: center;

          transition: all 0.2s ease;

          &:hover {
            color: ${props => props.theme.colors.secondary};
            border-color: ${props => rgba(props.theme.colors.secondary, 0.7)};
            transform: translateY(-1px);
          }
        }
      }
    }

    .HomeMockups__Wrapper {
      position: relative;
      top: 30px;
      left: -30px;
      perspective: 5000px;
      perspective-origin: left bottom;
      transform-style: flat;

      .mockup {
        position: absolute;
        width: 183px;
        height: 120px;

        border-radius: 10px;
        box-shadow: rgb(0 0 0 / 25%) 0px 20px 40px,
          rgb(255 255 255 / 20%) 0px 0px 0px 0.5px inset;

        &.image-1 {
          top: 150px;
          left: -37px;

          background: radial-gradient(
            218.51% 281.09% at 100% 100%,
            ${props => rgba(props.theme.colors.secondary, 0.6)} 0%,
            ${props => rgba(props.theme.colors.primary.darker, 0.8)} 45.83%,
            ${props => rgba(props.theme.colors.primary.darker, 0.8)} 100%
          );
          backdrop-filter: blur(10px);
        }
        &.image-2 {
          top: 150px;
          left: 176px;

          background: linear-gradient(
            192.64deg,
            ${props => props.theme.colors.primary.darker} 12.72%,
            rgb(144, 118, 231) 54.49%,
            rgb(162, 238, 255) 100.01%
          );
          backdrop-filter: blur(10px);
        }
        &.image-3,
        &.image-4,
        &.image-5 {
          background: ${props =>
            rgba(darken(0.55, props.theme.colors.primary.normal), 0.3)};
          /* background: rgba(23, 12, 61, 0.3); */
          backdrop-filter: blur(10px) contrast(0.94);
        }
        &.image-3 {
          width: 701px;
          height: 428px;
          top: 200px;
          left: 0px;
        }
        &.image-4 {
          width: 400px;
          height: 273px;
          top: 370px;
          left: 40px;

          box-shadow: rgb(255 255 255 / 20%) 0px 0px 0px 0.5px inset;
        }
        &.image-5 {
          width: 414px;
          height: 273px;
          top: 400px;
          left: 340px;

          box-shadow: rgb(255 255 255 / 20%) 0px 0px 0px 0.5px inset;
        }

        img {
          max-width: 100%;
          padding: 0;
          margin: 0 0 1.45rem;

          opacity: 0;
          animation: 1s ease 0s 1 normal forwards running fade-in;
        }

        @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
          box-shadow: rgb(255 255 255 / 20%) 0px 0px 0px 0.5px inset;
        }
      }

      @media (min-width: 450px) {
        & > * {
          transform: rotateY(-20deg) rotateX(20deg);
          transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
        }
        &:hover > * {
          transform: rotateY(0deg) rotateX(0deg);

          &.image-1 {
            transform: translate(-30px, -30px);
          }
          &.image-2 {
            transform: translate(0px, -30px);
          }
          &.image-3 {
            transform: translate(0px, 0px);
          }
          &.image-4 {
            transform: translate(-120px, 60px);
          }
          &.image-5 {
            transform: translate(30px, 30px);
          }
        }
      }
    }
  }

  .home-tabs {
    position: sticky;
    top: 1.2rem;
    z-index: 12;
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
    margin: 1.5rem 0 1rem;
    padding: 0.85rem;
    border-radius: 14px;
    border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
    background: ${props => rgba(props.theme.colors.background.dark, 0.65)};
    backdrop-filter: blur(12px);

    a {
      display: inline-flex;
      align-items: center;
      padding: 0.5rem 0.9rem;
      border-radius: 999px;
      border: 1px solid ${props => rgba(props.theme.colors.white, 0.14)};
      color: ${props => props.theme.colors.text.title};
      text-decoration: none;
      font-size: 0.95rem;
      font-weight: 500;
      transition: border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;

      &:hover {
        color: ${props => props.theme.colors.secondary};
        border-color: ${props => rgba(props.theme.colors.secondary, 0.7)};
        transform: translateY(-1px);
      }
    }
  }

  section {
    width: 100%;
    max-width: 1140px;
    min-height: 50vh;
    padding-top: 6rem;
    padding-bottom: 6rem;

    border-bottom: 1px solid ${props => props.theme.colors.tertiary};

    font-family: 'Poppins', sans-serif;
    line-height: 1.8rem;
    font-weight: 400;
    letter-spacing: 0.05rem;

    .row {
      --bs-gutter-x: 1.5rem;
      --bs-gutter-y: 0;

      display: flex;
      flex-wrap: wrap;
      row-gap: 1rem;

      margin-top: calc(var(--bs-gutter-y) * -1);
      margin-right: calc(var(--bs-gutter-x) / -2);
      margin-left: calc(var(--bs-gutter-x) / -2);

      & > * {
        flex-shrink: 0;
        width: 100%;
        max-width: 100%;
        padding-right: calc(var(--bs-gutter-x) / 2);
        padding-left: calc(var(--bs-gutter-x) / 2);
        margin-top: var(--bs-gutter-y);
      }
    }
    .col {
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 100%;
      }
      @media (min-width: 992px) {
        flex: 0 0 auto;
        width: 50%;
      }
    }

    &.bio {
      h2 {
        font-weight: 600;
        font-size: 6.2rem;
        line-height: 8rem;
        letter-spacing: -1px;
        padding-right: 0px;
        margin-bottom: 3.8rem;
      }

      p {
        font-size: 1.4rem;
        font-weight: 300;
        color: ${props => props.theme.colors.text.normal};

        & + p {
          margin-top: 2rem;
        }

        a {
          font-weight: 500;
          text-decoration: none;
          color: ${props => props.theme.colors.text.title};
        }
      }

      .proof-card {
        margin-top: 2.5rem;
        padding: 1.2rem 1.3rem;
        border-radius: 12px;
        border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
        background: ${props => rgba(props.theme.colors.background.dark, 0.45)};

        strong {
          display: block;
          margin-bottom: 0.35rem;
          font-size: 0.95rem;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: ${props => rgba(props.theme.colors.text.normal, 0.82)};
        }

        h4 {
          margin: 0 0 0.85rem;
          font-size: 1.5rem;
          line-height: 1.3;
          color: ${props => props.theme.colors.text.title};
        }

        ul {
          margin: 0;
          padding-left: 1.1rem;
        }

        li {
          font-size: 1.05rem;
          line-height: 1.7rem;
          color: ${props => rgba(props.theme.colors.text.normal, 0.95)};
        }

        li + li {
          margin-top: 0.45rem;
        }

        .proof-links {
          margin-top: 0.85rem;
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem 0.85rem;
        }

        .proof-links a {
          font-size: 0.92rem;
          font-weight: 500;
          text-decoration: none;
          color: ${props => props.theme.colors.text.title};
          border-bottom: 1px solid transparent;
          transition: color 0.2s ease, border-color 0.2s ease;
        }

        .proof-links a:hover {
          color: ${props => props.theme.colors.secondary};
          border-color: ${props => rgba(props.theme.colors.secondary, 0.7)};
        }
      }
    }

    &.featured {
      min-height: auto;
      padding-top: 5rem;
      padding-bottom: 5rem;

      .featured-header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 2rem;

        span {
          display: inline-flex;
          padding: 0.35rem 0.85rem;
          border-radius: 999px;
          border: 1px solid ${props => rgba(props.theme.colors.white, 0.15)};
          color: ${props => rgba(props.theme.colors.text.normal, 0.8)};
          font-size: 0.95rem;
          font-weight: 500;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        h3 {
          margin-top: 1.2rem;
          font-size: 3.6rem;
          line-height: 4.2rem;
          font-weight: 600;
          color: ${props => props.theme.colors.text.title};
        }

        .featured-link {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          color: ${props => props.theme.colors.text.title};
          font-size: 1rem;
          font-weight: 500;
          text-decoration: none;
          transition: color 0.2s ease, transform 0.2s ease;

          svg {
            transition: transform 0.2s ease;
          }

          &:hover {
            color: ${props => props.theme.colors.secondary};
            transform: translateX(2px);

            svg {
              transform: translateX(4px);
            }
          }
        }
      }

      .featured-grid {
        margin-top: 2.5rem;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1.6rem;

        > a {
          position: relative;
          display: flex;
          min-height: 220px;
          padding: 1.4rem;
          border-radius: 16px;
          border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
          background: ${props => rgba(props.theme.colors.background.dark, 0.5)};
          color: inherit;
          text-decoration: none;
          overflow: hidden;
          transition: transform 0.2s ease, border-color 0.2s ease;

          &:hover {
            transform: translateY(-3px);
            border-color: ${props => rgba(props.theme.colors.secondary, 0.7)};
          }
        }

        .text {
          max-width: 68%;
          z-index: 1;
        }

        h4 {
          margin: 0;
          color: ${props => props.theme.colors.text.title};
          font-size: 1.7rem;
          line-height: 1.2;
        }

        p {
          margin: 0.85rem 0 0;
          color: ${props => rgba(props.theme.colors.text.normal, 0.92)};
          font-size: 1rem;
          line-height: 1.55rem;
        }

        span {
          margin-top: 1.15rem;
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          color: ${props => props.theme.colors.secondary};
          font-size: 0.95rem;
          font-weight: 600;
        }

        .preview {
          position: absolute;
          right: 1rem;
          bottom: 1rem;
          width: 38%;
          height: 65%;
          border-radius: 12px;
          border: 1px solid ${props => rgba(props.theme.colors.white, 0.13)};
          background-size: cover;
          background-position: center;
          background-color: ${props =>
            rgba(darken(0.2, props.theme.colors.background.dark), 0.88)};
        }

        .preview.is-logo {
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    &.top-section {
      min-height: auto;
      padding-top: 4.5rem;
      padding-bottom: 4.5rem;
    }

    .section-heading {
      span {
        display: inline-flex;
        padding: 0.35rem 0.85rem;
        border-radius: 999px;
        border: 1px solid ${props => rgba(props.theme.colors.white, 0.15)};
        color: ${props => rgba(props.theme.colors.text.normal, 0.8)};
        font-size: 0.95rem;
        font-weight: 500;
        letter-spacing: 0.06em;
        text-transform: uppercase;
      }

      h3 {
        margin-top: 1.2rem;
        font-size: 3rem;
        line-height: 3.6rem;
        font-weight: 600;
        color: ${props => props.theme.colors.text.title};
      }
    }

    &.open-source {
      .open-source-grid {
        margin-top: 2rem;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
      }
    }

    &.experience {
      .experience-grid {
        margin-top: 2rem;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 1rem;
      }

      .experience-card {
        min-height: 220px;
        padding: 1.2rem;
        border-radius: 14px;
        border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
        background: ${props => rgba(props.theme.colors.background.dark, 0.45)};
      }

      .company-mark {
        width: fit-content;
        padding: 0.3rem 0.6rem;
        border-radius: 8px;
        background: ${props => rgba(props.theme.colors.primary.normal, 0.2)};
        border: 1px solid
          ${props => rgba(props.theme.colors.primary.normal, 0.35)};
        color: ${props => props.theme.colors.text.title};
        font-size: 0.85rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      h4 {
        margin: 0.95rem 0 0;
        color: ${props => props.theme.colors.text.title};
        font-size: 1.4rem;
      }

      p {
        margin-top: 0.8rem;
        color: ${props => rgba(props.theme.colors.text.normal, 0.95)};
        font-size: 1rem;
        line-height: 1.5rem;
      }
    }

    &.apps {
      .apps-note {
        margin-top: 1rem;
        max-width: 760px;
        color: ${props => rgba(props.theme.colors.text.normal, 0.88)};
        font-size: 1.05rem;
        line-height: 1.7rem;
      }

      .apps-grid {
        margin-top: 1.8rem;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
      }

      .app-card {
        padding: 1.2rem;
        border-radius: 14px;
        border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
        background: ${props => rgba(props.theme.colors.background.dark, 0.45)};

        h4 {
          margin: 0;
          color: ${props => props.theme.colors.text.title};
          font-size: 1.45rem;
          line-height: 1.2;
        }

        p {
          margin-top: 0.65rem;
          color: ${props => rgba(props.theme.colors.text.normal, 0.95)};
          font-size: 1rem;
          line-height: 1.5rem;
        }

        .store-links {
          margin-top: 1rem;
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;

          a {
            display: inline-flex;
            align-items: center;
            padding: 0.45rem 0.75rem;
            border-radius: 999px;
            border: 1px solid ${props => rgba(props.theme.colors.white, 0.15)};
            color: ${props => props.theme.colors.text.title};
            text-decoration: none;
            font-size: 0.92rem;
            font-weight: 500;
            transition: border-color 0.2s ease, color 0.2s ease;

            &:hover {
              color: ${props => props.theme.colors.secondary};
              border-color: ${props => rgba(props.theme.colors.secondary, 0.7)};
            }
          }
        }
      }
    }

    .section-card {
      position: relative;
      min-height: 220px;
      padding: 1.2rem;
      border-radius: 14px;
      border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
      background: ${props => rgba(props.theme.colors.background.dark, 0.45)};
      color: inherit;
      text-decoration: none;
      overflow: hidden;
      transition: transform 0.2s ease, border-color 0.2s ease;

      &:hover {
        transform: translateY(-2px);
        border-color: ${props => rgba(props.theme.colors.secondary, 0.65)};
      }

      .text {
        max-width: 68%;
      }

      h4 {
        margin: 0;
        color: ${props => props.theme.colors.text.title};
        font-size: 1.4rem;
      }

      p {
        margin-top: 0.8rem;
        color: ${props => rgba(props.theme.colors.text.normal, 0.95)};
        font-size: 1rem;
        line-height: 1.5rem;
      }

      span {
        margin-top: 1rem;
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        color: ${props => props.theme.colors.secondary};
        font-size: 0.92rem;
        font-weight: 600;
      }

      .preview {
        position: absolute;
        right: 0.9rem;
        bottom: 0.9rem;
        width: 35%;
        height: 60%;
        border-radius: 10px;
        border: 1px solid ${props => rgba(props.theme.colors.white, 0.12)};
        background-size: cover;
        background-position: center;
        background-color: ${props =>
          rgba(darken(0.2, props.theme.colors.background.dark), 0.88)};
      }

      .preview.is-logo {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    &.projects {
      color: ${props => props.theme.colors.text.normal};
      padding-top: 3rem;
      padding-bottom: 3rem;

      border: none;

      .row-title {
        --bs-gutter-x: 0.8rem;
        align-items: center;
        column-gap: 1.4rem;
        margin-right: 0;
        margin-left: 0;

        & > * {
          width: auto;
          max-width: none;
          padding-left: 0;
          padding-right: 0;
          margin-top: 0;
        }
      }

      span {
        opacity: 0.6;
        font-size: 1.4rem;
        font-weight: 300;
        text-align: left;
      }
      h3 {
        width: fit-content;
        margin: 2rem 0;
        font-size: 4.6rem;
        line-height: 5.2rem;
        font-weight: 500;
        text-transform: none;
      }
      p {
        font-size: 1.8rem;
        line-height: 3.9rem;
        font-weight: 300;
        text-transform: none;
      }

      .mockups {
        &.desktop {
          height: 428px;
          perspective: 5000px;
          perspective-origin: left bottom;
          transform-style: flat;

          > picture.mockup-asset {
            display: block;
            position: absolute;

            width: 701px;
            height: 428px;
            margin: 0 0 1.45rem;

            border-radius: 10px;
            box-shadow: rgb(0 0 0 / 25%) 0px 20px 40px,
              rgb(255 255 255 / 20%) 0px 0px 0px 0.5px inset;

            transform: rotateY(27deg) rotateX(57deg);
            transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;

            opacity: 0;
            animation: 1s ease 0s 1 normal forwards running fade-in;

            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: inherit;
            }

            &.mockup-asset-1 {
              top: 150px;
              left: 300px;
            }
            &.mockup-asset-2 {
              top: 50px;
              left: 176px;
            }
            &.mockup-asset-3 {
              top: 150px;
              left: 76px;
            }
          }

          &:hover > picture.mockup-asset {
            transform: rotateY(0deg) rotateX(0deg);

            &.mockup-asset-1 {
              transform: translate(80px, -120px);
            }
            &.mockup-asset-2 {
              transform: translate(-200px, -100px);
            }
            &.mockup-asset-3 {
              transform: translate(0px, 0px);
            }
          }
        }

        &.mobile {
          display: none;
        }
      }
    }

    &.landing-showcase,
    &.forms-showcase {
      padding-top: 3rem;
      padding-bottom: 3rem;
      border: none;

      .landing-head {
        margin-bottom: 1.2rem;

        .landing-tag {
          font-size: 0.95rem;
          font-weight: 400;
          opacity: 0.5;
          display: block;
          margin-bottom: 0.4rem;
        }

        h3 {
          font-size: 3.6rem;
          font-weight: 600;
          line-height: 1.1;
          color: ${props => props.theme.colors.text.title};
          margin: 0;
        }
      }

      .landing-desc {
        max-width: 540px;
        margin-bottom: 2.5rem;
        font-size: 1.1rem;
        line-height: 1.7;
        color: ${props => props.theme.colors.text.normal};
      }

      .landing-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1.5rem;

        .landing-card {
          margin: 0;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};
          background: ${props =>
            rgba(props.theme.colors.background.dark, 0.5)};

          .scroll-shot {
            --shot-height: 360px;
            --scroll-dur: 10s;

            position: relative;
            overflow: hidden;
            height: var(--shot-height);
            border-radius: 12px 12px 0 0;
            cursor: pointer;

            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: auto;
              min-height: 200%;
              display: block;
              animation: scroll-shot var(--scroll-dur) linear infinite;
              animation-play-state: paused;
            }

            &::after {
              content: '';
              position: absolute;
              inset: auto 0 0 0;
              height: 80px;
              pointer-events: none;
              background: linear-gradient(
                180deg,
                transparent,
                ${props => rgba(props.theme.colors.background.dark, 0.6)} 60%,
                ${props => rgba(props.theme.colors.background.dark, 0.95)}
              );
              opacity: 0.7;
              transition: opacity 0.4s ease;
            }

            &:hover img,
            &:focus-visible img {
              animation-play-state: running;
            }

            &:hover::after,
            &:focus-visible::after {
              opacity: 0;
            }
          }

          figcaption {
            padding: 0.9rem 1rem 1rem;
            font-size: 0.95rem;
            font-weight: 500;
            color: ${props => props.theme.colors.text.title};
            background: ${props =>
              rgba(props.theme.colors.background.dark, 0.9)};
          }
        }
      }

      &.forms-showcase .landing-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      @keyframes scroll-shot {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(calc(-100% + var(--shot-height)));
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .landing-grid .landing-card .scroll-shot img {
          animation: none;
        }
      }

      @media (max-width: 900px) {
        .landing-grid,
        &.forms-showcase .landing-grid {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 600px) {
        padding-top: 2rem;
        padding-bottom: 2rem;

        .landing-head h3 {
          font-size: 2.4rem;
        }

        .landing-grid .landing-card .scroll-shot {
          --shot-height: 300px;
        }
      }
    }

    &.legacy-forms {
      p {
        margin-bottom: 8rem;
      }
      img {
        width: 100%;
        box-shadow: rgb(0 0 0 / 25%) 0px 0px 40px 20px;
      }
    }

    &.legacy-ecoleta,
    &.legacy-plant {
      .alert {
        transform: translateY(4rem);
        display: flex;
        align-items: flex-end;

        svg {
          margin-left: 1rem;
        }
      }

      .swiper-container {
        width: 100vw;
        height: 100%;
        margin-top: 8rem;

        position: relative;
        left: -13%;
      }

      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;

        cursor: grab;

        &:active {
          cursor: grabbing;
        }
      }
      img {
        /* width: 30rem; */
        width: 100%;
        border-radius: 30px;

        @media (max-width: 600px) {
          border-radius: 16px;
        }
      }

      &.plant-manager {
        .swiper-slide {
          padding-right: 2.4rem;
        }
        .swiper-slide:last-child {
          padding-right: 0;
        }
      }
    }
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    90% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media only screen and (max-width: 1200px) {
    padding: 40px;
  }

  @media only screen and (max-width: 768px) {
    padding: 30px 20px;

    .home-tabs {
      top: 0.8rem;
      margin-top: 0.8rem;
      gap: 0.5rem;
      padding: 0.7rem;

      a {
        font-size: 0.85rem;
        padding: 0.45rem 0.7rem;
      }
    }

    .header {
      grid-template-columns: 360px auto;
    }

    section.featured {
      .featured-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));

        > a {
          min-height: 180px;
          padding: 1rem;
        }

        .text {
          max-width: 100%;
        }

        h4 {
          font-size: 1.15rem;
        }

        p {
          margin-top: 0.5rem;
          font-size: 0.9rem;
          line-height: 1.4rem;
        }

        span {
          margin-top: 0.8rem;
          font-size: 0.85rem;
        }

        .preview {
          display: none;
        }
      }
    }

    section.open-source .open-source-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));

      .section-card {
        min-height: 180px;
        padding: 1rem;

        .text {
          max-width: 100%;
        }

        h4 {
          font-size: 1.15rem;
        }

        p {
          margin-top: 0.5rem;
          font-size: 0.9rem;
          line-height: 1.4rem;
        }

        span {
          margin-top: 0.8rem;
          font-size: 0.85rem;
        }

        .preview {
          display: none;
        }
      }
    }

    section.experience .experience-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));

      .experience-card {
        min-height: auto;
        padding: 1rem;

        .company-mark {
          font-size: 0.75rem;
        }

        h4 {
          font-size: 1.05rem;
        }

        p {
          font-size: 0.85rem;
          line-height: 1.35rem;
        }
      }
    }

    section.apps .apps-grid {
      grid-template-columns: 1fr;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 0rem 2rem;

    .button {
      /* width: 18rem; */

      font-size: 1rem;
      font-weight: 500;
    }

    .header {
      height: 42rem;
      min-height: 0;
      max-height: none;
      align-content: start;

      padding: 0;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;

      .title-box {
        height: auto;
        min-height: 0;
        margin-top: clamp(2rem, 7svh, 4rem);
        gap: 1.25rem;
        position: relative;
        z-index: 2;

        h1 {
          font-size: 4.3rem;
          line-height: 4.3rem;
          letter-spacing: -2px;
        }

        span {
          font-size: 1.8rem;
          font-weight: 500;
          line-height: 130%;
        }
      }
      .HomeMockups__Wrapper {
        top: -3.5rem;
        left: -72px;
        transform: scale(0.47);
        z-index: 1;
      }
    }

    section {
      &.bio {
        padding-top: 0;

        h2 {
          font-weight: 600;
          font-size: 50px;
          line-height: 55px;
          letter-spacing: -1px;
          padding-right: 0px;
          margin-bottom: 50px;
        }

        .proof-card {
          h4 {
            font-size: 1.25rem;
          }

          li {
            font-size: 0.95rem;
            line-height: 1.55rem;
          }
        }
      }

      &.featured {
        .featured-header {
          flex-direction: column;
          align-items: flex-start;

          h3 {
            font-size: 2.6rem;
            line-height: 3rem;
          }
        }
      }

      .section-heading {
        h3 {
          font-size: 2.4rem;
          line-height: 2.9rem;
        }
      }

      .section-card {
        min-height: 190px;

        .text {
          max-width: 100%;
        }

        .preview {
          display: none;
        }
      }

      &.experience {
        .experience-grid {
          .experience-card {
            padding: 0.85rem;

            h4 {
              font-size: 0.95rem;
            }

            p {
              font-size: 0.8rem;
              line-height: 1.25rem;
            }
          }
        }
      }

      &.projects {
        h3 {
          font-size: 40px;
          line-height: 45px;
          letter-spacing: 0px;
        }
        span,
        p {
          font-size: 16px;
          line-height: 26px;
        }

        .mockups {
          &.desktop {
            display: none;
          }

          &.mobile {
            display: block;
            margin-top: 2rem;

            .swiper-container {
              width: 100vw;
              position: relative;
              left: -2rem;
              padding: 0 2rem;
              box-sizing: border-box;
            }

            .swiper-slide {
              display: flex;
              align-items: center;
              justify-content: center;
            }

            img {
              width: 100%;
              height: auto;
              border-radius: 8px;
              box-shadow: rgb(0 0 0 / 25%) 0px 10px 30px;
            }
          }
        }
      }

      &.legacy-ecoleta,
      &.legacy-plant {
        .alert {
          transform: none;
          margin-top: 1.2rem;
        }

        .swiper-container {
          margin-top: 1.1rem;
          left: 0;
          width: 100%;
        }

        .swiper-slide {
          align-items: flex-start;
          justify-content: flex-start;
        }

        .swiper-slide img {
          width: 100% !important;
          max-width: none;
          height: auto !important;
        }

        .swiper-slide > span {
          width: 100% !important;
          max-width: none !important;
        }
      }
    }
  }

  @media only screen and (max-width: 600px) and (max-height: 700px) {
    .header {
      height: 100svh;
      min-height: 100svh;

      .HomeMockups__Wrapper {
        top: -5.5rem;
        transform: scale(0.45);
      }
    }
  }
`
